// React imports
import React, { Component } from "react";
import { connect } from "react-redux";

// React Admin imports
import { Notification, translate } from "react-admin";

// Material Ui imports
import { withStyles } from "@material-ui/core/styles";

// Other imports
import AppBar from "../partials/AppBar";
import Sidebar from "../partials/Sidebar";
import Menu from "../partials/Menu";
import Footer from "../partials/Footer";
import compose from "recompose/compose";
import { colors } from "../tokens";

/* const CustomSidebar = props => <Sidebar size={240} {...props} />;
const CustomLayout = props => (
    <Layout appBar={AppBar} sidebar={CustomSidebar} {...props} />
); */

const styles = () => ({
  root: {
    display: "flex",
    flexDirection: "column",
    zIndex: 1,
    minHeight: "100vh",
    //backgroundColor: theme.palette.background.default,
    backgroundColor: colors.paper,
    position: "relative"
  },
  appFrame: {
    display: "flex",
    flexDirection: "column",
    overflowX: "auto"
  },
  contentWithSidebar: {
    display: "flex",
    flexGrow: 1
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 2,
    padding: "28px 20px 20px",
    marginTop: "0"
  },
  footerDivider: {
    borderTop: "1px solid " + colors.line,
    margin: "0 20px"
  }
});

class CustomLayout extends Component {
  /** The dashboard brings its own closing section, so it needs no footer line. */
  isDashboardRoute = () => {
    const { pathname } = this.props;
    const path =
      pathname ||
      (window.location.hash || "").replace(/^#/, "").split("?")[0] ||
      "/";
    return path === "/" || path.toLowerCase() === "/dashboard";
  };
  render() {
    const { children, classes, dashboard, logout, open, title } = this.props;

    return (
      <div className={classes.root}>
        <AppBar title={title} open={open} logout={logout} />
        <main className={classes.contentWithSidebar}>
          <Sidebar>
            <Menu logout={logout} hasDashboard={!!dashboard} />
          </Sidebar>
          <div
            id="contentTop"
            ref={ref => (this.myRef = ref)}
            style={{ minHeight: "650px" }}
            className={classes.content}
          >
            {children}
          </div>
        </main>

        {!this.isDashboardRoute() && <div className={classes.footerDivider} />}
        <footer>
          <Footer />
        </footer>
        <Notification />
      </div>
    );
  }
}

export default compose(
  translate,
  connect(state => ({
    isLoading: state.admin.loading > 0,
    pathname:
      state.router && state.router.location
        ? state.router.location.pathname
        : undefined
  })),
  withStyles(styles)
)(CustomLayout);
